import { render, staticRenderFns } from "./AmbulanciasTrasladosForaneos.vue?vue&type=template&id=1e41edc0"
import script from "./AmbulanciasTrasladosForaneos.vue?vue&type=script&lang=js"
export * from "./AmbulanciasTrasladosForaneos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports